import React, { useState } from 'react';
import { Dialog, Loading, Uploader, Checkbox } from '@tencent/spaui';

const EMPTY_VALUE = { _ept: null };

const { FileUploader } = Uploader;
/**
 * 使用原生方式制作动画效果
 */
const doImportFinishAnimation = (event, position) => {
  const getPosition = (elm, p) => {
    if (p) return {
      x: `${p.x  }px`,
      y: `${p.y  }px`,
    };
    if (!elm) return { x: '0px', y: '0px' };
    const { bottom, top, left, right } = elm.getBoundingClientRect();
    return {
      y: `${Math.round((top + bottom) / 2)}px`,
      x: `${Math.round((left + right) / 2)}px`,
    };
  };
  if (document.querySelector('.upload-animation-icon')) return;
  const target = document.querySelector('.icon-upload-end-target');
  const from = event.target;
  const start = getPosition(from, position);
  const end = getPosition(target);
  const icon = document.createElement('i');
  icon.className = 'upload-animation-icon';
  icon.style.setProperty('--x-start', start.x);
  icon.style.setProperty('--y-start', start.y);
  icon.style.setProperty('--x-end', end.x);
  icon.style.setProperty('--y-end', end.y);
  const animationFinishedCallback = () => {
    document.body.removeChild(icon);
    // 使用本地持久化在用户导入成功后将离线中心图标的状态标记为未读
    localStorage.setItem('CACHE_IS_UPLOAD_UNREAD', true);
    // 手动调用修改离线中心图标状态的方法
    if (typeof window._unsafe_set_upload_unread === 'function') {
      window._unsafe_set_upload_unread(true);
    }
    // 因为曲线动画拆分成了 X 和 Y 两部分，所以会触发 2 次，第二次会报错，所以加下面一行取消掉第二次的
    icon.removeEventListener('animationend', animationFinishedCallback);
  };
  icon.addEventListener('animationend', animationFinishedCallback);
  document.body.appendChild(icon);
};

const getImportWarnKey = () => {
  const id = window.pageProps.operationUserId;
  if (id === undefined || id === '') return;
  return `_cache_import_warn_confirmed_${id}`;
};

const shouldImportWarn = () => {
  const key = getImportWarnKey();
  const cache = localStorage.getItem(key);
  return cache !== 'true';
};

const importWarnConfirm = () => {
  const key = getImportWarnKey();
  localStorage.setItem(key, 'true');
  return true;
};

const leadsImportHeader = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' };
export const LeadsUploadDialog = (props) => {
  const [leadsImportUploadedFile, setLeadsImportUploadedFile] = useState('');
  const [leadsImportPercent, setLeadsImportPercent] = useState(EMPTY_VALUE);
  const [leadsImportSuccessNum, setLeadsImportSuccessNum] = useState('');
  const [leadsImportFailNum, setLeadsImportFailNum] = useState('');
  const [leadsImportDuplicatedNum, setLeadsImportDuplicatedNum] = useState('');
  const [leadsImportFailResultFile, setLeadsImportFailResultFile] = useState('');
  const leadsImportUpLoad = `${props.leadsUploadApi || '/api/v1/leads/upload_offline_leads_file'}?accountId=${window.pageProps.uid}&csrfToken=${window.pageProps.token}`;
  const [leadsImportLoadingShow, setLeadsImportLoadingShow] = useState(false);
  const [successLeadsImportShow, setSuccessLeadsImportShow] = useState(false);
  const [errorLeadsImportShow, setErrorLeadsImportShow] = useState(false);
  const [showImportWarning, setShowImportWarning] = useState(false);
  const [noMoreImportWarn, setNoMoreImportWarn] = useState(false);

  const successLeadsImportClose = () => {
    setSuccessLeadsImportShow(false);
  };
  const handleCloseLeadsImport = () => {
    setLeadsImportUploadedFile('');
    props.hideLeadsImport();
    setLeadsImportPercent(EMPTY_VALUE);
    setShowImportWarning(false);
  };
  const errorLeadsImportClose = () => {
    setErrorLeadsImportShow(false);
  };
  const handleLeadsImportDelete = () => {
    setLeadsImportPercent(EMPTY_VALUE);
  };
  const handleLeadsImportComplete = (response, fileTarget) => {
    const { data } = response;
    if (response.code == 0) {
      setLeadsImportPercent({
        url: 'http://www.placehold.it/300x300',
        message: '',
        status: 'success',
      });
      // 修复上传之后可能会没有名称的 bug，这个 bug 看着像是 UI 组件的 bug
      const titleElm = document.querySelector('.spaui-upfile-label');
      if (titleElm) titleElm.innerHTML = fileTarget.name;
      setLeadsImportUploadedFile({
        fileName: fileTarget.name,
        fileKey: data.fileKey || data,
        taskType: props.taskType,
      });
    } else {
      setLeadsImportPercent({
        url: 'http://www.placehold.it/300x300',
        message: response.msg,
        status: 'fail',
      });
      setLeadsImportUploadedFile('');
    }
  };
  const handleSubmitLeadsImport = (e) => {
    if (!leadsImportUploadedFile) return;
    const btnPosition = e.target.getBoundingClientRect();
    if (props.importWarning && !showImportWarning && shouldImportWarn()) {
      props.hideLeadsImport();
      setShowImportWarning(true);
      return;
    }
    if (props.importType !== 'old') {
      props.updateLeadsImport(
        window.pageProps.uid,
        leadsImportUploadedFile,
      ).done(() => {
        doImportFinishAnimation(e, btnPosition);
        handleCloseLeadsImport(); // 关闭弹窗
        noMoreImportWarn && importWarnConfirm();
        setNoMoreImportWarn(false);
      }).fail((status, msg) => {
        noMoreImportWarn && importWarnConfirm();
        setNoMoreImportWarn(false);
        if (showImportWarning) {
          handleCloseLeadsImport();
          setTimeout(() => alert(msg), 20);
          return;
        }
        alert(msg);
      });
    } else {
      setLeadsImportLoadingShow(true);
      props.updateLeadsImport(
        window.pageProps.uid,
        leadsImportUploadedFile.fileKey,
      ).done((data) => {
        const { failNum } = data;
        if (failNum <= 0) {
          setLeadsImportSuccessNum(data.successNum);
          setSuccessLeadsImportShow(true);
          setLeadsImportLoadingShow(false);
        } else {
          // 部分成功
          setLeadsImportFailNum(data.failNum - (data.duplicateNum || 0));
          setLeadsImportSuccessNum(data.successNum);
          setLeadsImportDuplicatedNum(data.duplicateNum);
          setLeadsImportLoadingShow(false);
          setErrorLeadsImportShow(true);
          setLeadsImportFailResultFile(data.failResultFile);
        }
        setTimeout(props.query, 1000);
      }).fail((status, msg) => {
        alert(`请求失败，msg:${msg},status:${status}`);
        setLeadsImportLoadingShow(false);
      });
    }
  };

  return (
    <div>
      <Loading show={leadsImportLoadingShow} type="page" />
      <Dialog
        show={successLeadsImportShow}
        style={{ width: '300px' }}
        timeCallback={successLeadsImportClose}
        time={2000}
        type="tip"
        iconType="success"
      >
        您已成功{props.actionName || '导入'}
        {leadsImportSuccessNum}条线索
      </Dialog>

      <Dialog
        type="normal"
        className="spaui-dialog-confirm-normal modal-lead-upfail"
        title={`部分线索${props.actionName || '导入'}失败`}
        iconType="warning"
        show={errorLeadsImportShow}
        onClose={errorLeadsImportClose}
        onSubmit={errorLeadsImportClose}
        onCancel={errorLeadsImportClose}
      >
        <div>
          成功{props.actionName || '导入'}线索{leadsImportSuccessNum}条, {props.actionName === '导入' ? `线索去重${leadsImportDuplicatedNum}条，` : ''}失败{leadsImportFailNum}条
        </div>
        <a
          href={`${props.downloadFailFileApi ||
            '/api/v1/leads/download_fail_leads_import'}?failLeadsResultPath=${leadsImportFailResultFile}&accountId=${
            window.pageProps.uid
          }`}
          target="_blank" rel="noreferrer"
        >
          下载失败列表
        </a>
      </Dialog>

      {
        props.importWarning && (
          <Dialog
            show={showImportWarning}
            style={{ width: '400px' }}
            type="normal"
            title="用户需知"
            cancelLabel="暂不导入"
            submitLabel="继续导入"
            onClose={handleCloseLeadsImport}
            onCancel={handleCloseLeadsImport}
            onSubmit={handleSubmitLeadsImport}
          >
            { props.importWarning }
            <br />
            <Checkbox
              checked={noMoreImportWarn}
              onChange={() => setNoMoreImportWarn(s => !s)}
              style={{
                '--checkbox-radius': '2px',
                float: 'right',
                position: 'relative',
                bottom: '-10px',
                userSelect: 'none',
              }}
            >
              以后不再提示
            </Checkbox>
          </Dialog>
        )
      }

      <Dialog
        type="normal"
        className="modal-lead-uper"
        enabledBackdropClose
        backdrop
        title={props.dialogTitle}
        submitLabel="导入"
        show={props.isShowLeadsImport}
        style={{ width: '600px' }}
        onClose={handleCloseLeadsImport}
        onSubmit={handleSubmitLeadsImport}
        onCancel={handleCloseLeadsImport}
      >
        <div className="lead-uper">
          <div className="uparea">
            <FileUploader
              className="multi-mark-upload"
              accept="*/*"
              name={props.uploadParaName || 'uploadedFile4LeadsImport'}
              headers={leadsImportHeader}
              url={leadsImportUpLoad}
              value={leadsImportPercent}
              onDelete={handleLeadsImportDelete}
              onComplete={handleLeadsImportComplete}
            ></FileUploader>
            <div style={{ marginTop: '10px', color: 'red', textAlign: 'center' }}>{leadsImportPercent.message}</div>
            {
              props.importType === "old"
                ? (<p className="tips">EXCEL表格，2MB，1000条数据以内</p>)
                : (<p className="tips">EXCEL表格，50MB，10万条数据以内</p>)
            }
          </div>
          {props.importDetail || (
            <div className="exp">
              <p className="tt">不知道如何导入线索？</p>
              <p className="step">
                第一步：下载
                <a target="_blank" href="/assets/doc/offline_leads_import_template.xlsx">
                  文件模板
                </a>
                ，按模板要求填写，模板表头信息不支持变更
              </p>
              <p className="step">第二步：在上方上传您填写好的文件，开始导入</p>
              <p className="exp-tip">
                模板文件中姓名为必填项，手机号、座机、QQ、微信至少填写一项，其他信息可选填，更改、删除及调换顺序都会导致线索无法成功导入。
              </p>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
};
